import MenuLabel from '@/components/MenuLabel';
import { getMenuPermission } from '@/services/user';
import { getUuid } from '@/utils';
import { setLocalStorage } from '@/utils/cookies';
import { MenuItemProps as AntdMenuItemProps } from '@sinohealth/butterfly-ui-components/lib';
import routerConfig from './router';
const { NODE_ENV } = process.env;
export const isDev = NODE_ENV === 'development';

let menuConfig: MenuItemProps[] = [
  {
    label: '首页',
    key: 'index',
    path: 'index',
  },
  {
    label: '患者管理',
    key: 'patient',
    children: [
      {
        label: '管理列表',
        path: '/patient/list',
        icon: <span className={'iconfont icon-contacts'} />,
      },
      {
        label: <MenuLabel label="患者咨询" field={'consultUnreadCount'} />,
        path: '/patient/consult',
        icon: <span className={'iconfont icon-message'} />,
      },
      {
        label: '患者邀请',
        path: '/patient/invite',
        icon: <span className={'iconfont icon-apartment'} />,
      },
      {
        label: '院内患者',
        path: '/patient/infirmary',
        icon: <span className={'iconfont icon-contacts'} />,
      },
    ],
  },
  {
    label: '患者服务',
    key: 'patientService',
    children: [
      {
        label: '预警管理',
        path: '/patientService/earlyWarning',
      },
      {
        label: '待办管理',
        path: '/patientService/todoList',
      },
    ],
  },
  {
    label: '项目跟进',
    key: 'follow',
    children: [
      {
        label: '项目跟进统计',
        path: '/follow/count',
        icon: <span className="iconfont icon-project"></span>,
      },
      {
        label: '项目跟进列表',
        path: '/follow/list',
        icon: <span className="iconfont icon-genjinjilu"></span>,
      },
      {
        label: '导入记录',
        path: '/follow/importRecord',
        icon: <span className="iconfont icon-caozuorizhi"></span>,
      },
    ],
  },
  {
    label: 'QC审核',
    key: 'qc',
    children: [
      {
        label: '审核工作台',
        path: '/qc/workbench',
        icon: <span className="iconfont icon-genjinjilu"></span>,
      },
      {
        label: 'QC记录查询',
        path: '/qc/record',
        icon: <span className="iconfont icon-caozuorizhi"></span>,
      },
      {
        label: 'QC工作日历',
        path: '/qc/calendar',
        icon: <span className="iconfont icon-project"></span>,
      },
      {
        label: 'QC人员分组',
        path: '/qc/group',
        icon: <span className="iconfont icon-project"></span>,
      },
      {
        label: 'QC统计报表',
        path: '/qc/report',
        icon: <span className="iconfont icon-project"></span>,
      },
    ],
  },
  {
    label: '项目资料',
    key: 'project',
    children: [
      {
        label: '项目资料库',
        path: '/project/list',
        icon: <span className="iconfont icon-print"></span>,
      },
    ],
  },

  {
    label: '配置',
    key: 'setting',
    children: [
      {
        label: '科室管理',
        path: '/setting/department',
      },
      {
        label: '角色管理',
        path: '/setting/role',
      },
      {
        label: '员工管理',
        path: '/setting/employees',
      },
      {
        label: '标签管理',
        path: '/setting/tag/classify',
      },
    ],
  },
  {
    label: '个人中心',
    key: 'personal',
    visible: false,
    children: [
      {
        label: '资料设置',
        path: '/personal/dataSettings',
      },
      {
        label: '修改密码',
        path: '/personal/changePassword',
      },
      {
        label: '登录记录',
        path: '/personal/loginRecord',
      },
    ],
  },
  {
    label: '消息通知',
    key: 'message',
    visible: false,
    children: [
      {
        label: <MenuLabel label={'申请通知'} field={'applyUnreadCount'} />,
        path: '/message/applyMessage',
      },
      {
        label: <MenuLabel label={'系统通知'} field={'sysUnreadCount'} />,
        path: '/message/sysMessage',
      },
    ],
  },
  {
    label: '企微管理',
    key: 'weComManage',
    children: [
      {
        label: '全部客户',
        path: '/weComManage/allCustom',
      },
      {
        label: '企微授权',
        path: '/weComManage/empower',
      },
    ],
  },
  {
    label: '数据导出',
    key: 'dataExport',
    children: [
      {
        label: '知情同意书导出',
        path: '/dataExport/consentExport',
      },
      {
        label: '患者档案导出',
        path: '/dataExport/infoExport',
      },
      {
        label: '上传资料图片导出',
        path: '/dataExport/fileExport',
      },
      {
        label: '导出记录',
        path: '/dataExport/record',
      },
    ],
  },
];

const msgMenuItemField: any = {
  '/message/applyMessage': 'applyUnreadCount',
  '/message/sysMessage': 'sysUnreadCount',
  '/patient/consult': 'consultUnreadCount',
};
// 菜单需要显示未读红点的情况，需要兼容动态路由配置，菜单数据由接口获取时，通过path判断是否需要展示红点
export const getMsgMenuLabel = (path: string, label: string) => {
  if (!msgMenuItemField[path]) return label;
  return <MenuLabel label={label} field={msgMenuItemField[path]} />;
};
export class MenuItem {
  parent: MenuItem | null;

  key: string = '';

  children: MenuItem[];

  path: string = '';

  constructor(props: MenuItemProps) {
    Object.assign(this, props);
    this.parent = props.parent || null;
    this.key = props.key || props.path || getUuid();
    this.children = props.children
      ? props.children.map((config) => new MenuItem({ ...config, parent: this }))
      : [];
  }
}

export interface MenuItemProps extends AntdMenuItemProps {
  label: any;
  key?: string;
  path?: string;
  visible?: boolean;
  parent?: MenuItem;
  children?: MenuItemProps[];
}

export function mapMenuConfig(menu: MenuItem[], fn: any) {
  menu.forEach((item) => {
    fn(item);
    if (item.children) {
      mapMenuConfig(item.children, fn);
    }
  });
}

export function mapMenuParent(menuItem: MenuItem, fn: any) {
  if (menuItem.parent) {
    fn(menuItem.parent);
    mapMenuParent(menuItem.parent, fn);
  }
}

// 根据页面资源code从路由表配置提取页面菜单路径
const getPathFormRouterConfig = (code: string) => {
  const allRoute = routerConfig[0].children || [];
  const pagePath = allRoute.filter((item: any) => item.code === code)[0];
  return pagePath?.path;
};
// 转换后台配置的菜单数据为本地要求的菜单数据格式
const transformAsyncMenuConfig = (menus: any) => {
  return menus.map((item: any) => {
    const code = item.data?.resourceCode;
    const visible = item.data?.visible;
    return {
      label: item.name,
      path: code && getPathFormRouterConfig(code),
      visible: visible,
      children: item.children ? transformAsyncMenuConfig(item.children) : [],
    };
  });
};
// export function getMenuConfig() {
//   return Promise.resolve(menuConfig.map((config) => new MenuItem(config)));
// }
// 获取菜单配置数据
export function getMenuConfig() {
  if (isDev && false) return Promise.resolve(menuConfig.map((config) => new MenuItem(config)));
  return getMenuPermission().then((data: any) => {
    // 缓存
    setLocalStorage('permission', data.permission);
    const newMenuConfig = transformAsyncMenuConfig(data.menu);
    // 加一个判断，如果是开发环境用上面那一份，如果是生产环境，取接口返回的
    return newMenuConfig.map((config: any) => new MenuItem(config));
  });
}

export default menuConfig;
